import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/home/runner/work/platform/platform/packages/ops-dashboard/src/components/forms/forgot-password-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnboardingFooter"] */ "/home/runner/work/platform/platform/packages/ops-dashboard/src/components/ui/onboarding/footer.tsx");
